// extracted by mini-css-extract-plugin
export var image = "SheetHero-module--image--a1fe0";
export var wrapper = "SheetHero-module--wrapper--f2b38";
export var wrapperImage = "SheetHero-module--wrapperImage--c4b3d";